/**
 *
 * Asynchronously loads the component for CloudAccounts
 *
 */

import { lazyLoad } from 'utils/loadable';

export const CloudAccounts = lazyLoad(
  // @ts-ignore
  () => import('./index.tsx'),
  module => module.CloudAccounts,
);
